export const commercialKindOptions = [
  { value: 'internal_base', label: 'Base própria' },
  { value: 'available_to_everyone', label: 'Externo' },
];
